<fm-balloon-header
  #header
  i18n-title="@@S_CLUSTER_BALLOON_FLEET_TITLE"
  title="Fleet ({{ balloon.clusteredItems?.length }})"
  color="black"
></fm-balloon-header>

<fm-balloon-section #itemList class="cluster-balloon__list" [showDivider]="false">
  <cdk-virtual-scroll-viewport
    *ngIf="balloon?.clusteredItems?.length > 4"
    itemSize="52"
    class="cluster-balloon__list__virtual-scroll-viewport"
  >
    <ng-container
      *cdkVirtualFor="let item of balloon?.clusteredItems | objectFieldSort: 'label'"
      [ngTemplateOutlet]="clusterListItem"
      [ngTemplateOutletContext]="{ item: item }"
    ></ng-container>
  </cdk-virtual-scroll-viewport>

  <ng-container *ngIf="balloon?.clusteredItems?.length <= 4">
    <!-- This case is supported to not require the full height virtual scroll balloon for small clusters -->
    <ng-container
      *ngFor="let item of balloon?.clusteredItems | objectFieldSort: 'label'"
      [ngTemplateOutlet]="clusterListItem"
      [ngTemplateOutletContext]="{ item: item }"
    ></ng-container>
  </ng-container>
</fm-balloon-section>

<fm-balloon-actions>
  <button mat-button class="vzc-small" a7s-id="live-map-cluster-balloon-zoom-to" i18n="@@S_ZOOM_TO" (click)="onZoomTo()">Zoom To</button>
</fm-balloon-actions>

<ng-template #clusterListItem let-item="item">
  <div class="cluster-balloon__list__item" (click)="onItemClicked(item)" (contextmenu)="onItemRightClick($event, item)">
    <span class="cluster-balloon__list__item__left-column">
      <mat-icon class="cluster-balloon__list__item__icon mat-icon-size-special" [svgIcon]="'ic-' + item?.iconClass"></mat-icon>
      <div class="cluster-balloon__list__item__text">
        <span class="cluster-balloon__list__item__text__label" [fmTooltip]="item?.label" [showTooltipIfOverflow]="true">{{
          item?.label
        }}</span>
        <span
          *ngIf="hasDriver(item)"
          class="cluster-balloon__list__item__text__driver"
          [fmTooltip]="item?.driver"
          [showTooltipIfOverflow]="true"
          >{{ item?.driver }}
        </span>
      </div>
    </span>
    <fm-ev-battery-section
      *ngIf="item?.evBatteryData"
      [isCharging]="item.status === EVehicleStatusType.Charging"
      [percentage]="item.evBatteryData.batteryPercentage"
      [userSettings]="userSettings"
      [vehicleStatus]="item.status"
      [batteryUpdateTime]="item.evBatteryData.batteryLastUpdateTime"
    >
    </fm-ev-battery-section>
  </div>
</ng-template>
